/**
 * Функция для расчета размеров внутреннего контейнера (например, изображения) с учетом соотношения сторон.
 * Позволяет сохранить пропорции изображения, чтобы оно вписывалось в заданные размеры контейнера.
 *
 * @param imageWidth - Ширина изображения.
 * @param imageHeight - Высота изображения.
 * @param containerWidth - Ширина контейнера, в который нужно вписать изображение.
 * @param containerHeight - Высота контейнера, в который нужно вписать изображение.
 * @returns  Объект с рассчитанными шириной и высотой.
 *   Если ширина или высота изображения равны 0, возвращает `{ width: '100%', height: '100%' }`.
 */
export const calculateInnerBoxDimensions = (
  imageWidth: number,
  imageHeight: number,
  containerWidth: number,
  containerHeight: number,
) => {
  const imageAspectRatio = imageWidth / imageHeight;
  const containerAspectRatio = containerWidth / containerHeight;

  if (imageAspectRatio > containerAspectRatio) {
    const calculatedHeight = containerWidth / imageAspectRatio;
    return { width: containerWidth, height: calculatedHeight };
  } else {
    const calculatedWidth = containerHeight * imageAspectRatio;
    return { width: calculatedWidth, height: containerHeight };
  }
};
